export interface RefundCheckDto {
  type: RefundTypeEnum;
  amount: number;
  message: string;
}

export interface CreateRefundDto {
  iban: string;
  bic: string;
}

export enum RefundTypeEnum {
  NA = "NA",
  DESK = "DESK",
  BANK = "BANK",
  CARD = "CARD",
}